import { Button, Col, Image, Input, Modal, Radio, Row, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import { SaveOutlined, RollbackOutlined, CheckOutlined, UploadOutlined, DoubleRightOutlined } from '@ant-design/icons';
import { SetPaymentByFish_FoodAndParking_Reserve_Api } from '../../API/ReserveApi';

// -----------------------------------------------------------
import DateObject from "react-date-object";
// وارد کردن DatePicker و تنظیمات شمسی درست
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// -----------------------------------------------------------

// =================================================================
const SERVER_DATE_FORMAT = "YYYY-MM-DD";

/**
 * تابع کمکی برای تبدیل ارقام فارسی/عربی به انگلیسی و تبدیل اسلش به خط تیره.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    let output = String(str).trim();

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    return output.replace(/\//g, "-");
};

// =================================================================
/**
 * آداپتور سفارشی PersianDatePickerAdapter برای فیلد تاریخ واریز
 */
const PersianDatePickerAdapter = ({ value, onChange, placeholder, disabled }) => {
    let initialValue = null;
    if (value) {
        // تاریخ شمسی "YYYY-MM-DD"
        const parts = persianToEnglishNumbers(value).split('-');
        if (parts.length === 3) {
            try {
                // ایجاد تاریخ با استفاده از تقویم شمسی برای نمایش صحیح
                initialValue = new persian().setDate(parseInt(parts[0]), parseInt(parts[1]), parseInt(parts[2]));
            } catch (e) {
                console.error("Error creating initial Persian date:", e);
                initialValue = null;
            }
        }
    }

    const handleOnChange = (dateObject) => {
        let dateString = null;
        if (dateObject && !Array.isArray(dateObject)) {
            // خروجی در فرمت YYYY-MM-DD با خط تیره و ارقام انگلیسی
            dateString = persianToEnglishNumbers(dateObject.format(SERVER_DATE_FORMAT));
        }
        onChange(dateString);
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={initialValue}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input"
            calendarPosition="bottom-right"
            format={SERVER_DATE_FORMAT} // برای نمایش به صورت YYYY-MM-DD
            placeholder={placeholder}
            disabled={disabled} // اعمال وضعیت disabled
        />
    );
};
// =================================================================

export const PaymentComponent_FoodAndParking = ({
    setLoading,
    showMessage,
    reserve,
    period,
    onPayCompleted,
    reportMode = false
}) => {
    // =================================================================
    const [selectedPeymentType, setSelectedPaymentType] = useState(1);
    const [fishCode, setFishCode] = useState("");
    const [paymentDate, setPaymentDate] = useState(null); // تاریخ به فرمت YYYY-MM-DD
    const [file, setFile] = useState(null);
    const [currentFileList, setCurrentFileList] = useState([]);

    // =================================================================
    useEffect(() => {
        loadData();
    }, []);
    // =================================================================
    const loadData = async () => {
        let defaultPaymentType = 1;
        
        // منطق انتخاب پیش‌فرض پرداخت (از propsهای FoodAndParking استفاده می‌کند)
        if (period.enableElectronicPay_FoodAndParking) {
            defaultPaymentType = 1;
        } else if (period.enablePayByFish_FoodAndParking) {
            defaultPaymentType = 2;
        }

        if (reserve.paymentType_FoodAndParking === "PayByFish") {
            defaultPaymentType = 2;
        }

        // در حالت گزارش، نوع پرداخت را بر اساس دیتابیس تنظیم کنید
        if (reportMode && reserve.paymentType_FoodAndParking === "PayByFish") {
             setSelectedPaymentType(2);
        } else {
             setSelectedPaymentType(defaultPaymentType);
        }
       
        setFishCode(reserve.fishCode_FoodAndParking || "");

        // تنظیم تاریخ واریز از اطلاعات رزرو
        const shamsiDate = reserve.paymentDate_Shamsi_FoodAndParking ? persianToEnglishNumbers(reserve.paymentDate_Shamsi_FoodAndParking) : null;
        setPaymentDate(shamsiDate);

        // تنظیم لیست فایل فعلی برای نمایش فایل قبلی
        if (reserve.fishFileURL_FoodAndParking) {
            setCurrentFileList([{
                uid: '-1',
                name: 'فیش واریزی موجود',
                status: 'done',
                url: reserve.fishFileURL_FoodAndParking,
            }]);
        } else {
            setCurrentFileList([]);
        }
        setFile(null); // در بارگذاری مجدد فایل جدید را ریست می کنیم
    }
    // =================================================================
    const onPayTypeChange = (e) => {
        setSelectedPaymentType(e.target.value);
    };
    // =================================================================
    const handleFileChange = (info) => {
        const { fileList } = info;
        
        // فقط آخرین فایل را نگه دار
        const newFileList = fileList.slice(-1);
        
        if (newFileList.length > 0) {
            const currentFile = newFileList[0];
            
            // اگر فایل انتخاب شده (و نه فایل سروری)
            if (currentFile.originFileObj) {
                setFile(currentFile.originFileObj);
                setCurrentFileList([{
                    ...currentFile,
                    status: 'done',
                }]);
            }
        } else {
            // اگر همه فایل‌ها حذف شدند
            setFile(null);
            if (reserve.fishFileURL_FoodAndParking) {
                // اگر فایل قبلی در سرور وجود دارد، آن را نمایش بده
                setCurrentFileList([{
                    uid: '-1',
                    name: 'فیش واریزی موجود',
                    status: 'done',
                    url: reserve.fishFileURL_FoodAndParking,
                }]);
            } else {
                setCurrentFileList([]);
            }
        }
    };
    
    // تابع حذف فایل
    const handleRemoveFile = (fileToRemove) => {
        // اگر فایل سروری حذف شود
        if (fileToRemove.uid === '-1') {
            // فقط از لیست حذف کن - در سرور تغییری ایجاد نمی‌کنیم
            setCurrentFileList([]);
            setFile(null);
        } else {
            // اگر فایل جدید حذف شود
            setFile(null);
            if (reserve.fishFileURL_FoodAndParking) {
                // فایل سروری را دوباره نمایش بده
                setCurrentFileList([{
                    uid: '-1',
                    name: 'فیش واریزی موجود',
                    status: 'done',
                    url: reserve.fishFileURL_FoodAndParking,
                }]);
            } else {
                setCurrentFileList([]);
            }
        }
        return true; // اجازه حذف به antd بده
    };
    // =================================================================
const shamsiStringToJSDate = (shamsiStr) => {  
  if (!shamsiStr) return null;  
  const parts = persianToEnglishNumbers(shamsiStr).split("-");  
  if (parts.length !== 3) return null;  
  const y = parseInt(parts[0], 10);  
  const m = parseInt(parts[1], 10);  
  const d = parseInt(parts[2], 10);  
  try {  
    const sh = new DateObject({ calendar: persian, locale: persian_fa, year: y, month: m, day: d });  
    return sh.toDate();  
  } catch (e) {  
    // fallback: if toDate not available, use JS Date from components (month-1)  
    try {  
      return new Date(y, m - 1, d);  
    } catch (e2) {  
      return null;  
    }  
  }  
};
    // =================================================================

    const onSubmitFish = async (values) => {
        try {
            if (!paymentDate) {
                showMessage("یک تاریخ واریز معتبر وارد کنید.", "error");
                return;
            }

const paymentJSDate = shamsiStringToJSDate(paymentDate);  
    if (!paymentJSDate) {  
      showMessage("تاریخ وارد شده معتبر نیست.", "error");  
      return;  
    }  

    // امروز بدون زمان  
    const now = new Date();  
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());  

    // شرط 1: تاریخ فیش نباید بعد از امروز باشد  
    const paymentNoTime = new Date(paymentJSDate.getFullYear(), paymentJSDate.getMonth(), paymentJSDate.getDate());  
    if (paymentNoTime > today) {  
      showMessage("تاریخ واریز نمی‌تواند بعد از امروز باشد.", "error");  
      return;  
    }  




            // اگر فایلی جدید انتخاب نشده و فایل قبلی هم وجود ندارد
            if (!file && !reserve.fishFileURL_FoodAndParking) {
                showMessage("تصویر فیش واریزی را انتخاب کنید.", "error");
                return;
            }

            if (!fishCode) {
                showMessage("شماره فیش معتبر وارد کنید.", "error");
                return;
            }

            setLoading(true);
            //////////////////////////////
            const formData = new FormData();
            
            if (file) {
                formData.append("photo", file);
            }

            formData.append("reserveId", reserve.id);
            formData.append("paymentDate", paymentDate);
            formData.append("fishCode", fishCode);

            let data = await SetPaymentByFish_FoodAndParking_Reserve_Api(formData);
            
            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful");
                if (onPayCompleted) onPayCompleted();
            }
            else {
                showMessage(data.message, "error");
            }
        }
        catch (error) {
            showMessage("خطا در ارتباط با سرور", "error");
        }
        finally {
            setLoading(false);
        }
    };
    // =================================================================
    return (
        <>
            {/* در حالت گزارش (reportMode)، این بخش نمایش داده نمی‌شود تا نوع پرداخت ثابت بماند */}
            {!reportMode ?
                <>
                    <div className='container'>
                        <Radio.Group onChange={onPayTypeChange} value={selectedPeymentType} style={{ width: '100%' }}>
                            <Row justify='center' style={{ paddingTop: '8px', paddingBottom: '8px' }}>

                                {/* گزینه پرداخت الکترونیک */}
                                {period.enableElectronicPay ?
                                    <Col xs={12} sm={12} md={12} lg={6} xl={6} >
                                        <Radio value={1}>پرداخت الکترونیک</Radio>
                                    </Col> : <></>}

                                {/* گزینه ثبت فیش واریزی */}
                                {period.enablePayByFish ?
                                    <Col xs={12} sm={12} md={12} lg={6} xl={6} >
                                        <Radio value={2}> ثبت فیش واریزی</Radio>
                                    </Col> : <></>}
                            </Row>
                        </Radio.Group>
                    </div>

                    {selectedPeymentType === 1 ?
                        <div className='container'>
                            {/* محتوای پرداخت الکترونیک - دکمه هدایت به درگاه */}
                            <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                برای ادامه فرآیند پرداخت، لطفاً دکمه "پرداخت الکترونیک" را فشار دهید.
                            </p>
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <Button 
                                    type="primary" 
                                    size="large"
                                    // onClick={...} // در اینجا باید تابع هدایت به درگاه پرداخت قرار گیرد
                                >
                                    <SaveOutlined />
                                    پرداخت الکترونیک
                                </Button>
                            </div>
                        </div> : <></>
                    }
                </> : <></>}
            
            {/* بخش ثبت فیش واریزی (Report Mode یا Normal Mode) */}
            {selectedPeymentType === 2 ?
                <>
                    <div className='container'>
                        <Row gutter={[16, 16]}>


                            <Col xs={12} sm={12} md={5} lg={2} xl={2} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                                شماره فیش:
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={3} xl={3} className='valueColumn'>
                                <Input 
                                    disabled={reportMode} // اعمال وضعیت disabled
                                    placeholder='شماره فیش' 
                                    value={fishCode} 
                                    onChange={(e) => { setFishCode(e.target.value) }} 
                                    style={{ textAlign: 'right' }} 
                                />
                            </Col>

                            <Col xs={0} sm={0} md={0} lg={1} xl={1} />

                            <Col xs={12} sm={12} md={5} lg={2} xl={2} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                                تاریخ واریز: {paymentDate}
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={3} xl={3} className='valueColumn'>
                                <PersianDatePickerAdapter 
                                    disabled={reportMode} // اعمال وضعیت disabled
                                    value={paymentDate} 
                                    placeholder="تاریخ واریز" 
                                    onChange={setPaymentDate} 
                                />
                            </Col>

                            <Col xs={0} sm={0} md={2} lg={1} xl={1} />

                            <Col xs={24} sm={24} md={11} lg={3} xl={3} className='valueColumn'>
                                {/* دکمه آپلود فقط در حالت عادی نمایش داده می‌شود */}
                                {!reportMode ?
                                    <Upload
                                        beforeUpload={() => false}
                                        onChange={handleFileChange}
                                        onRemove={handleRemoveFile}
                                        accept="image/*"
                                        maxCount={1}
                                        fileList={currentFileList}
                                    >
                                        <Button icon={<UploadOutlined />} style={{ width: '100%' }}> تصویر فیش واریزی</Button>
                                    </Upload> : <></>}
                            </Col>

                            <Col span={24} style={{ marginTop: '20px', textAlign: 'center' }}>
                                {/* نمایش تصویر فیش واریزی */}
                                {reserve.fishFileURL_FoodAndParking && (
                                    <Image
                                        style={{ border: '2px solid #cdcdcd', borderRadius: '10px', maxWidth: '300px', maxHeight: '300px' }}
                                        src={reserve.fishFileURL_FoodAndParking} 
                                        alt="تصویر فیش واریزی"
                                    />
                                )}
                            </Col>


                        </Row>

                    </div>
                    {/* دکمه "ثبت فیش" فقط در حالت عادی نمایش داده می‌شود */}
                    {!reportMode ?
                        <Row className='sectionFooter'>
                            <Col xs={12} sm={12} md={16} lg={18} xl={18} >
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6} >
                                <Button
                                    style={{ width: '98%' }}
                                    className='btn-primary'
                                    htmlType="button"
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'آیا از صحت اطلاعات اطمینان دارید؟',
                                            onOk: () => { onSubmitFish() },
                                            footer: (_, { OkBtn, CancelBtn }) => (
                                                <>
                                                    <CancelBtn />
                                                    <OkBtn />
                                                </>
                                            ),
                                        });
                                    }}
                                >
                                    <CheckOutlined />
                                    ثبت فیش
                                </Button>
                            </Col>
                        </Row>
                        : <></>}

                </> : <></>
            }

        </>
    )
}